module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionDetails) ? _c('b-modal', {
    ref: "missionBannerImageModal",
    attrs: {
      "id": "missionBannerImageModal",
      "title": _vm.$t('mission.modal.bannerImage'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.setMissionBannerImageData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.uploadMissionBannerImage($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.missionBannerImageData.url) ? _c('div', {
    staticClass: "col text-center"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "150px"
    },
    attrs: {
      "src": _vm.missionBannerImageData.url
    }
  }), _vm._v(" "), _c('br'), _c('br')]) : _c('div', {
    staticClass: "col text-center font-italic"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('mission.bannerImage.notSelected')) + "\n            "), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.bannerImage'),
      "state": _vm.missionBannerImageState,
      "feedback": _vm.missionBannerImageFeedback,
      "description": _vm.$t('mission.bannerImage.description')
    }
  }, [_c('b-form-file', {
    ref: "missionBannerImageSelection",
    attrs: {
      "id": "missionBannerImageSelection",
      "accept": "image/jpeg, image/png, image/gif",
      "choose-label": _vm.$t('mission.bannerImage.choose')
    },
    model: {
      value: (_vm.missionBannerImageData.file),
      callback: function($$v) {
        _vm.missionBannerImageData.file = $$v
      },
      expression: "missionBannerImageData.file"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission banner image actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.uploadMissionBannerImage
    }
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.upload')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "danger",
      "disabled": !_vm.missionBannerImageData.url
    },
    on: {
      "click": _vm.deleteMissionBannerImage
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.delete')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionBannerImageModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51549375"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/modals/MissionBannerImageModal.vue
// module id = 519
// module chunks = 0